import { render } from "./PeoplePicker.vue?vue&type=template&id=2e2f9d04&ts=true"
import script from "./PeoplePicker.vue?vue&type=script&lang=ts"
export * from "./PeoplePicker.vue?vue&type=script&lang=ts"

import "./PeoplePicker.vue?vue&type=style&index=0&id=2e2f9d04&lang=scss"

import exportComponent from "/home/issa/hcpet/hcpet-kasse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__